module.exports = __webpack_public_path__ + "img/xtnl-006.19e59f7b.png";